import { IFormattedGeojson, ILayersData } from '../types/layers';

export function splitGeojson(geojson: ILayersData[]): IFormattedGeojson[] {
  const validGeojson = geojson.filter(geo => geo.geojson.features !== null);
  const formattedGeojsons: IFormattedGeojson[] = [];

  for (let i = 0; i < validGeojson.length; i += 1) {
    if (validGeojson[i].geojson.features) {
      for (let j = 0; j < validGeojson[i].geojson.features.length; j += 1) {
        const newGeojson = {
          type: validGeojson[i].geojson.features[j].type,
          name: validGeojson[i].geojson.features[j].properties.name,
          properties: validGeojson[i].geojson.features[j].properties,
          geometry: validGeojson[i].geojson.features[j].geometry,
        };
        formattedGeojsons.push(newGeojson);
      }
    }
  }

  return formattedGeojsons;
}
